<template>    
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container d-flex flex-column">
                <header class="mdc-top-app-bar position-static">
                    <div class="mdc-top-app-bar__row">
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                            <a class="material-icons mdc-top-app-bar__navigation-icon" @click="closeIssue()">close</a>
                        </section>
                        
                        <section class="mdc-top-app-bar__section title">
                            <div class="mdc-top-app-bar__title">
                                {{$t('45')}}
                                <!-- 문항 이슈 등록 -->
                            </div>
                        </section>

                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                            <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
                        </section>
                    </div>
                    
                </header>
                <section class="flex-grow-1 scroll-y">
                    <div class="pda-default">
                        <div class="t-headline9">
                            {{$t('46')}}
                            <!-- 시험 문항 이슈 등록 -->
                        </div>
                        <div class="t-body3 t-color-bodyGrayA mgt-6">
                            {{$t('47')}}
                            <!-- 시험 문항 또는 결과에 이의가 있으신 경우 의견 또는 이슈 내용을 입력해주세요. -->
                        </div>

                        <div class="mgt-35">
                            <div class="mdc-text-field mdc-text-field--textarea mdc-text-field--fullwidth" :id="`issueEl`">
                                <div class="mdc-text-field-character-counter"></div>
                                <textarea id="textarea" class="mdc-text-field__input" rows="5"
                                    maxlength="200"
                                    v-model="contents"
                                ></textarea>
                                <div class="mdc-notched-outline">
                                    <div class="mdc-notched-outline__leading"></div>
                                    <div class="mdc-notched-outline__notch">
                                        <label for="text-field-hero-input" class="mdc-floating-label">
                                            {{$t('48')}}
                                            <!-- 의견 또는 이슈 입력 (최대 200자) -->
                                        </label>
                                    </div>
                                    <div class="mdc-notched-outline__trailing"></div>
                                </div>
                            </div>
                        </div>

                        <div class="mgt-50 bottom-btn">
                            <button class="mdc-button mdc-button--raised btn-red" @click="requestIssue()" :disabled="!checkValid">
                                {{$t('49')}}
                                <!-- 완료 -->
                            </button>
                            <button class="mdc-button btn-white mgr-8 mgl-8 t-color-secondaryBtnText" type="button" @click="closeIssue()">
                                {{$t('50')}}
                                <!-- 취소 -->
                            </button>
                        </div>


                    </div>
                </section>
                
            </div>
        </div>
        
    </div>
</template>

<script>
/**
 * 시험 문항 이슈제기 컴포넌트(exam question issue component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import examApi from '@/api/examApi.js'
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'

export default {
    data() {
        return {
            issueEl: null,
            contents: ''
        }
    },

    computed: {
        // contents 유효성 체크(validation check contents)
        checkValid() {
            return !!this.contents
        },

    },

    mounted() {
        this.issueEl = new MDCTextField(document.querySelector(`#issueEl`))
        this.setMaterialUi()
    },

    methods: {
        // 이슈 등록(regist issue)
        requestIssue() {
            let params = {
                contents: this.contents,
                examineeId: this.$route.params.examineeId,
                questionId: this.$route.params.questionId,
            }

            // call api issue regist
            examApi.issue(params).then((response) => {
                this.closeIssue()
            }).catch((err) => {
                this.closeIssue()
            })
        },

        // 이슈 등록 취소(cancel issue)
        closeIssue() {
            this.$router.go(-1)
        },
        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },
    }
}
</script>